import React from "react"
import { useHistory } from "react-router-dom"
import { useAtendimento } from "../../contexts/AtendimentoContext"
import { useAuth } from "../../hooks/Auth"
import {ContainerSidebar} from "./styles"
import { IconHome } from "./Svgs"

const Sidebar: React.FC<any> = ({ menu }) => {
    const { user } = useAuth();
    const history = useHistory();
    const { setFilter } = useAtendimento();
    async function handleOnNavigate(link: any) {
        setFilter({
            Search: "",
            CodigoCliente: "",
            NomeCliente: "",
            CodigoLojaCliente: "",
            TipoContrato: "",
            AtendimentoEndereco_NomeLocal: "",
            AtendimentoEndereco_UF: "",
            AtendimentoEndereco_Cidade: "",
            idUsuarioTecnico: "",
            SemTecnicoAtribuido: "",
            Status: "",
            TipoAtendimentoId: "",
            DataHoraAbertura: "",
            DataHoraAberturaFinal: "",
            DataHoraInicioAtendimento: "",
            DataHoraTerminoAtendimento: "",
        })
        history.push(link)
    }

    return (
        <ContainerSidebar>
            <nav>


                <button 
                    className={``}
                    onClick={() =>{history.push('/home')}}
                >
                    <span className="icon"><i className="fa-solid fa-house"></i></span>
                    <span className="text">Home</span>
                </button>
                <button 
                    className={``}
                    onClick={() =>{history.push('/clientes')}}
                >
                    <span className="icon"><i className="fa-solid fa-user-tie"></i></span>
                    <span className="text">Clientes</span>
                </button>

                <button 
                    className={``}
                    onClick={() =>{history.push('/colaboradores')}}
                >
                    <span className="icon"><i className="fa-solid fa-user"></i></span>
                    <span className="text">Colaboradores</span>
                </button>

                <button 
                    className={``}
                    onClick={() =>{history.push('/contas')}}
                >
                    <span className="icon"><i className="fa fa-university" aria-hidden="true"></i></span>
                    <span className="text">Contas</span>
                </button>

                <button 
                    className={``}
                    onClick={() =>{history.push('/contratos')}}
                >
                    <span className="icon"><i className="fa-solid fa-file-contract"></i></span>
                    <span className="text">Contratos</span>
                </button>

                <button 
                    className={``}
                    onClick={() =>{history.push('/despesas')}}
                >
                    <span className="icon"><i className="fa-solid fa-file-invoice-dollar"></i></span>
                    <span className="text">Despesas</span>
                </button>

                <button 
                    className={``}
                    onClick={() =>{history.push('/entradas')}}
                >
                    <span className="icon"><i className="fa-solid fa-money-bill-1"></i></span>
                    <span className="text">Entradas</span>
                </button>

                <button 
                    className={``}
                    onClick={() =>{history.push('/saidas')}}
                >
                    <span className="icon"><i className="fa-solid fa-hand-holding-dollar"></i></span>
                    <span className="text">Saidas</span>
                </button>

                <button 
                    className={``}
                    onClick={() =>{history.push('/tipo-pagamento')}}
                >
                    <span className="icon"><i className="fa-solid fa-percent"></i></span>
                    <span className="text">Tipos de Pagamento</span>
                </button>

            </nav>
        </ContainerSidebar>
    )
}

export default Sidebar